import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { ToastProvider } from './components/ToastProvider';
import './components/ToastProvider.css';
import Home from './pages/Home';
import DownloadApp from './pages/DownloadApp';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import StoreOwnerTerms from './pages/StoreOwnerTerms';
import CustomerTerms from './pages/CustomerTerms';
import Contact from './pages/Contact';

export default function App() {
  return (
    <ToastProvider>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/download" element={<DownloadApp />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/store-owner-terms" element={<StoreOwnerTerms />} />
        <Route path="/customer-terms" element={<CustomerTerms />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </ToastProvider>
  );
}
